<!--使用量列表-->
<template>
  <div>
    <div class="content-header">
      <div class="left">
        <span class="title">消费统计</span>
      </div>
      <!-- <Button type="primary" style="margin: 0 5px 1px 0" @click="exportData">导出Excel</Button>
          <Input search enter-button="搜索" placeholder="全局搜索" @on-search="globalSearch" /> -->
    </div>
    <div class="tips" style="margin-bottom: 20px">
      <Icon type="md-alert" size="20" color="#2d8cf0" style="margin-right: 10px" />
      <div>
        1.请勿将下列报表与机器用户工具“计数器列表”的数据进行比对，可能会存在差异，下列报表数据是通过云知印用户的作业订单进行统计
        <p>
          2.默认导出当前页面数据，如需要导出更多数据，请点击页面底部工具条进行调整后再执行导出。<br />
          3.以下显示的数据均已换算成A4单面进行展示，A3和双面自动2倍，已去除空白页（比如原稿3页打印1份双面，出纸数即为3页）
        </p>
      </div>
    </div>
    <div>
      <div class="filter-box">
        <div>
          <span class="subtitle">统计角度:</span>
          <Select
            v-model="current_type"
            @on-change="condChange(true)"
            style="width: 262px; margin-left: 10px"
          >
            <!-- <Option v-for="(item,index) in Object.keys(type)" :key="index" :value="item">{{type[item]}}</Option> -->
            <Option :value="'0'">设备角度</Option>
            <Option :value="'1'">企业角度</Option>
            <!-- <Option :value="'2'" v-if="!user.tp">合作伙伴角度</Option> -->
            <Option :value="'3'">站点角度</Option>
          </Select>
          <!-- @on-change="selectChange" -->
          <span class="subtitle" style="margin-left: 10px">品牌:</span>
          <Select
            v-model="selectBrand"
            style="width: 200px; margin-left: 10px"
            multiple
            :max-tag-count="1"
            @on-change="brandChange"
          >
            <Option
              v-for="(item, index) in machineTypeBrand"
              :key="index"
              :value="item"
              >{{ item }}</Option
            >
          </Select>
          <Select
            v-model="select_id"
            style="width: 200px; margin-left: 10px"
            :multiple="select_multiple"
            filterable
            :max-tag-count="1"
            v-if="current_type === '0'"
          >
            <Option value="-1">所有设备</Option>
            <Option v-for="(item, index) in machine_all" :key="index" :value="item.id">{{
              item.sn
            }}</Option>
          </Select>
          <Select
            v-model="select_id"
            style="width: 200px; margin-left: 10px"
            :multiple="select_multiple"
            :max-tag-count="1"
            v-if="current_type === '1'"
          >
            <Option value="-1">所有企业</Option>
            <Option v-for="(item, index) in company_all" :key="index" :value="item.id">{{
              item.company_name
            }}</Option>
          </Select>
          <Select
            v-model="select_id"
            style="width: 200px; margin-left: 10px"
            :multiple="select_multiple"
            :max-tag-count="1"
            v-if="current_type === '3'"
          >
            <Option value="-1">所有站点</Option>
            <Option v-for="(item, index) in site_all" :key="index" :value="item.id">{{
              item.name
            }}</Option>
          </Select>
          <span class="subtitle" style="margin-left: 10px" v-if="current_type != 1"
            >用户类型:</span
          >
          <Select
            v-model="page.role"
            :multiple="role_multiple"
            @on-change="roleChange"
            style="width: 240px; margin-left: 5px"
            placeholder="全部"
            v-if="current_type != 1"
          >
            <Option v-for="item in roleList" :value="item.value" :key="item.value">{{
              item.label
            }}</Option>
          </Select>

          <!-- <span class="subtitle" style="margin-left: 20px">支付方式:</span>
          <Select
            class="select"
            @on-change="money_type_change"
            v-model="page.money_type"
            :multiple="money_type_multiple"
            style="width: 200px; margin-left: 5px"
          >
            <Option value="-1">全部</Option>
            <Option
              v-for="(item, index) in Object.keys(money_type_list)"
              :key="index"
              :value="item"
              >{{ money_type_list[item].name }}</Option
            >
          </Select> -->
        </div>
        <div style="margin-top: 10px">
          <span class="subtitle">查询时间:</span>
          <DatePicker
            type="date"
            v-model="page.start"
            @on-change="changeDate"
            placeholder="开始时间"
            style="width: 120px; margin-left: 10px"
          ></DatePicker>
          <span style="margin-left: 5px">至</span>
          <DatePicker
            type="date"
            v-model="page.end"
            @on-change="changeDate"
            placeholder="结束时间"
            style="width: 120px; margin-left: 5px"
          ></DatePicker>
          <RadioGroup
            type="button"
            style="margin-left: 10px"
            v-model="radio"
            @on-change="onChangeSelectData"
          >
            <Radio v-if="user.tp" label="0">
              <span>昨&nbsp;&nbsp;日</span>
            </Radio>
            <Radio v-else label="0">
              <span>今&nbsp;&nbsp;日</span>
            </Radio>
            <Radio label="1">
              <span>本 月</span>
            </Radio>
            <Radio label="2">
              <span>上 月</span>
            </Radio>
          </RadioGroup>

          <span class="subtitle" style="margin-left: 12px">自定查找:</span>
          <Input
            style="width: 240px; margin-left: 6px"
            placeholder="关键字查找"
            v-model.trim="page.search"
          />
          <!-- <Checkbox style="margin-left: 12px" v-model="page.is_del" v-if="current_type === '0'">查询已删除设备</Checkbox> -->
        </div>
        <!-- <div style="margin-top: 10px" v-if="!user.tp">
          <span class="subtitle">合作伙伴:</span>
          <Select
            v-model="page.agent_id"
            style="width: 200px; margin-left: 10px"
          >
            <Option :value="0">所有合作伙伴</Option>
            <Option
              v-for="(item, index) in agent"
              :key="index"
              :value="item.id"
              >{{ item.name }}</Option
            >
          </Select>
          </div> -->
        <div class="bottom">
          <span class="btn-filter" @click="filterRequest()">筛选</span>
          <span class="btn" @click="reset">清空</span>
          <span class="btn" @click="exportData">导出报表</span>
        </div>

        <!-- <Select
          v-model="select_id"
          @on-change="selectChange"
          style="width:150px;margin-left:5px"
          v-if="current_type === '1'"
        >
          <Option :value="0">所有企业</Option>
          <Option
            v-for="(item,index) in company"
            :key="index"
            :value="item.id"
          >{{item.company_name}}</Option>
          </Select> -->
      </div>
      <div class="table_box" style="position: relative">
        <table class="table" id="table">
          <tr class="header">
            <td rowspan="2" v-if="current_type == '0'">序列号</td>
            <td rowspan="2" v-if="current_type == '0'">站点</td>
            <td rowspan="2" v-if="current_type == '0'">设备位置</td>
            <td rowspan="2" v-if="current_type == '0'">合作伙伴</td>

            <td rowspan="2" v-if="current_type == '1'">企业名称</td>
            <td rowspan="2" v-if="current_type == '1'">合作伙伴</td>

            <td rowspan="2" v-if="current_type == '2'">合作伙伴</td>

            <td rowspan="2" v-if="current_type == '3'">站点</td>
            <td rowspan="2" v-if="current_type == '3'">合作伙伴</td>

            <td rowspan="2">类型</td>
            <td rowspan="2">次数</td>
            <td rowspan="2">页数</td>
            <td colspan="5">黑白</td>
            <td colspan="5">彩色</td>
            <td rowspan="2">彩色百分比</td>
            <td rowspan="2">双面页数</td>
            <td rowspan="2">双面百分比</td>
            <td rowspan="2">费用</td>
          </tr>
          <tr class="header">
            <td>A3</td>
            <td>A4</td>
            <td>A5</td>
            <td>其他</td>
            <td>总数</td>
            <td>A3</td>
            <td>A4</td>
            <td>A5</td>
            <td>其他</td>
            <td>总数</td>
          </tr>
          <tbody
            v-for="(item, index) in current_type === '0'
              ? machine
              : current_type === '1'
              ? company
              : current_type === '2'
              ? agent
              : site"
            :key="index"
            v-if="!item.hide"
          >
            <tr
              v-for="(tp, j) in item.value"
              :key="j"
              :class="tp.type === 4 ? 'total' : ''"
            >
              <td :rowspan="j === 0 ? 4 : 1" v-if="current_type == '0' && j == 0">
                {{ item.sn }}
              </td>
              <td :rowspan="j === 0 ? 4 : 1" v-if="current_type == '0' && j == 0">
                {{ item.site_name }}
              </td>

              <td :rowspan="j === 0 ? 4 : 1" v-if="current_type == '0' && j == 0">
                {{ item.address }}
                {{ item.address !== item.address_detail ? item.address_detail : "" }}
              </td>
              <td :rowspan="j === 0 ? 4 : 1" v-if="current_type == '0' && j == 0">
                {{ item.agent_name }}
              </td>

              <td :rowspan="j === 0 ? 4 : 1" v-if="current_type == '1' && j == 0">
                {{ item.company_name }}
              </td>
              <td :rowspan="j === 0 ? 4 : 1" v-if="current_type == '1' && j == 0">
                {{ item.agent_name }}
              </td>

              <td :rowspan="j === 0 ? 4 : 1" v-if="current_type == '2' && j == 0">
                {{ item.name }}
              </td>

              <td :rowspan="j === 0 ? 4 : 1" v-if="current_type == '3' && j == 0">
                {{ item.name }}
              </td>
              <td :rowspan="j === 0 ? 4 : 1" v-if="current_type == '3' && j == 0">
                {{ item.agent_name }}
              </td>

              <td>{{ tp.text }}</td>
              <td>{{ tp.num }}</td>
              <!-- <td>{{tp.result_pages}}</td> -->
              <td>
                {{
                  tp.total_pages + tp.A30Other + tp.A31Other + tp.A40Other + tp.A41Other
                }}
              </td>
              <!-- <td>{{tp.total_pages}}-{{tp.total_pages + tp.A30Other + tp.A31Other + tp.A40Other + tp.A41Other}} {{tp.A30Other }}-{{ tp.A31Other }}-{{ tp.A40Other }}-{{ tp.A41Other}}</td> -->
              <td>{{ tp.A30 }}</td>
              <td>{{ tp.A40 + tp.A40Other }}</td>
              <!-- <td>{{tp.A40+ tp.A40Other}}</td> -->
              <td>{{ tp.A50 }}</td>
              <td>{{ tp.other0 }}</td>
              <td>{{ tp.A3450 + tp.A30Other + tp.A40Other }}</td>
              <!-- <td>{{tp.A3450}}-{{tp.A3450 + tp.A30Other + tp.A40Other}} {{tp.A30Other }}-{{ tp.A40Other }}</td> -->
              <td>{{ tp.A31 }}</td>
              <td>{{ tp.A41 + tp.A41Other }}</td>
              <td>{{ tp.A51 }}</td>
              <td>{{ tp.other1 }}</td>
              <td>{{ tp.A3451 + tp.A31Other + tp.A41Other }}</td>
              <!-- <td>{{tp.A3451}}-{{tp.A3451 + tp.A31Other + tp.A41Other}} {{tp.A31Other }}-{{ tp.A41Other }}</td> -->
              <td>{{ tp.colorRatio }}</td>
              <td>{{ tp.duplex }}</td>
              <td>{{ tp.duplexRatio }}</td>
              <td>{{ tp.money.toFixed(2) }}</td>
            </tr>
          </tbody>
        </table>
        <div style="font-size: 14px; color: #000; text-align: right; margin-top: 10px">
          合计：次数:{{ summary.count ? summary.count : 0 }} 页数:{{
            summary.pages ? summary.pages : 0
          }}
          打印:{{ summary.print ? summary.print : 0 }} 扫描:{{
            summary.scan ? summary.scan : 0
          }}
          黑白:{{ summary.black ? summary.black : 0 }} 彩色:{{
            summary.color ? summary.color : 0
          }}
          费用:{{ summary.money ? summary.money : 0 }}
        </div>
        <Spin fix v-if="loading">
          <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
          <div>加载中...</div>
        </Spin>
      </div>
      <div class="t-right">
        <Page
          @on-change="pageChange"
          @on-page-size-change="sizeChange"
          :current="page.p + 1"
          :total="total"
          :page-size="page.l"
          show-elevator
          show-sizer
          show-total
        />
        <div @click="showAllData" class="show_all">显示所有页</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import SeniorSearch from "_c/senior_search";
import excel from "@/libs/excel";
import { monDiff, verifyDate } from "@/libs/util";
export default {
  components: {
    SeniorSearch,
  },
  data() {
    this.type = {
      0: "设备角度",
      1: "企业角度",
      2: "合作伙伴角度",
      3: "站点角度",
    };
    return {
      page: {
        p: 0,
        l: 10,
        start: "",
        end: "",
        role: "-1",
        agent_id: 0,
        money_type: "-1", //支付方式
        search: "", //关键字
        is_del: false,
      },
      role_multiple: false,
      select_id: "-1", //选择的设备ID
      select_multiple: false,
      current_type: "0", //统计角度
      loading: false,

      radio: "0",
      total: 0,
      machine: [],
      machine_all: [],
      company: [],
      company_all: [],
      agent: [],
      agent_all: [],
      site: [],

      search: "",
      roleList: [
        {
          value: "-1",
          label: "全部",
        },
        {
          value: 1,
          label: "游客",
        },
        {
          value: 2,
          label: "个人会员",
        },
        {
          value: 3,
          label: "企业会员",
        },
      ],
      total: 0,
      summary: {
        count: 0,
        pages: 0,
        black: 0,
        color: 0,
        money: 0,
        scan: 0,
        print: 0,
      },
      money_type_list: {
        "-1": { name: "" },
        0: { name: "钱包" },
        1: { name: "微信" },
        2: { name: "支付宝" },
        3: { name: "免费" },
        4: { name: "企业钱包" },
        5: { name: "员工配额" },
        // 6: { name: "临时配额" },
        6: { name: "员工钱包" },
      },
      money_type_multiple: false,
      machineTypeBrand: [],
      selectBrand: [],
    };
  },
  mounted() {
    if (this.$route.params && this.$route.params.agent_id) {
      this.page.agent_id = this.$route.params.agent_id;
      /*  const start = this.$moment(
        new Date(
          new Date(new Date().setMonth(new Date().getMonth() - 1)).setDate(1)
        ),
        "YYYY-MM-DD"
      );
      const end =
        this.$moment(new Date().setDate(0), "YYYY-MM-DD");
        console.log('start, end',start, end)
      this.page.date = [start, end]; */
      this.radio = "2";
      this.curMonth();
      this.condChange();
    } else this.getData();
    // this.date = ["2020-05-19", "2020-05-20"];

    // this.getDataAgent();
    this.GetMachineTypeGroup().then((res) => {
      this.machineTypeBrand = res.map((item) => {
        return item.brand;
      });
    });
  },
  methods: {
    //筛选
    filterRequest() {
      if (verifyDate(this.page.start, this.page.end)) {
        this.$Message.error("开始时间不能大于结束时间");
        return;
      }
      if (monDiff(this.page.start, this.page.end) > 12) {
        //如果时间跨度超过一年就提示
        this.$Message.error("筛选的时间跨度不能超过12个月");
        return;
      }
      this.page.p = 0;
      this.condChange();
    },
    //本月
    curMonth(isCur) {
      let now = new Date();
      let a = isCur ? 1 : 0;
      let last = new Date(now.getFullYear(), now.getMonth() + a, 0);
      this.page.start = this.$moment(last, "YYYY-MM") + "-01";
      this.page.end = this.$moment(last, "YYYY-MM-DD");
    },
    sizeChange(l) {
      this.page.l = l;
      this.condChange();
    },
    pageChange(p) {
      this.page.p = p - 1;
      this.condChange();
    },
    exportData() {
      excel.export_table_to_excel("table", "消费统计.xlsx");
    },
    globalSearch(value) {
      this.search = value;
      this.condChange();
    },
    selectChange() {
      if (typeof this.select_id == "number" || typeof this.select_id == "object") {
        this.select_multiple = true;
        if (typeof this.select_id == "object" && this.select_id.indexOf("-1") >= 0) {
          this.select_multiple = false;
          this.select_id = "-1";
        }
      } else {
        this.select_multiple = false;
      }
      let temp =
        this.current_type === "0"
          ? "machine"
          : this.current_type === "1"
          ? "company"
          : this.current_type === "2"
          ? "agent"
          : "site";
      this[temp].map((item) => {
        if (typeof this.select_id == "object") {
          item.hide = true;
          this.select_id.map((i) => {
            if (item.id === i) {
              item.hide = false;
            }
          });
        } else {
          if (this.select_id === "-1") {
            item.hide = false;
          } else {
            item.hide = item.id !== this.select_id;
          }
        }
      });
    },
    condChange(setPage) {
      let now = new Date();
      if (setPage) {
        this.selectBrand = []
        this.page.p = 0;
        this.page.role = "-1";
        this.role_multiple = false;

        this.select_id = "-1";
        if (this.user.tp) {
          //合作伙伴显示昨日
          let yesterday = new Date(new Date() - 1000 * 60 * 60 * 24);
          this.page.start = this.$moment(yesterday, "YYYY-MM-DD");
          this.page.end = this.$moment(yesterday, "YYYY-MM-DD");
        } else {
          //总后台显示今日
          this.page.start = this.$moment(now, "YYYY-MM-DD");
          this.page.end = this.$moment(now, "YYYY-MM-DD");
        }
        this.page.search = "";
        this.radio = "0";
      }
      this.loading = true;
      switch (this.current_type) {
        case "0":
          this.GetDataMachine({
            brand: this.selectBrand,
            search: this.page.search,
            agent_id: this.page.agent_id,
            p: 0,
            l: 10000,
            is_del: this.page.is_del ? 1 : 0,
          }).then((res) => {
            this.machine_all = res.data;
          });

          // if(!this.machine.length){
          this.GetDataMachine({
            id: this.select_id,
            search: this.page.search,
            agent_id: this.page.agent_id,
            p: this.page.p,
            l: this.page.l,
            is_del: this.page.is_del ? 1 : 0,
            brand: this.selectBrand,
          }).then((res) => {
            this.formatData(res.data);
            this.machine = res.data;
            this.total = res.total;
            if (this.select_id !== "-1") {
              this.selectChange();
            }
            console.log("筛选", this.machine);
          });
          // }
          break;
        case "1":
          this.GetDataCompany({
            // id: this.select_id,
            search: this.page.search,
            agent_id: this.page.agent_id,
            p: 0,
            l: 10000,
          }).then((res) => {
            this.company_all = res.data;
          });

          // if(!this.company.length){
          this.GetDataCompany({
            id: this.select_id,
            search: this.page.search,
            agent_id: this.page.agent_id,
            p: this.page.p,
            l: this.page.l,
          }).then((res) => {
            this.formatData(res.data);
            this.company = res.data;
            this.total = res.total;
          });
          // }
          break;
        // case "2"://合作伙伴角度
        //   // if(!this.agent.length){
        //   this.GetDataAgent({
        //     search: this.page.search,
        //     p: this.page.p,
        //     l: this.page.l,
        //   }).then((res) => {
        //     this.formatData(res.data);
        //     this.agent = res.data;
        //     this.total = res.total;
        //   });
        //   // }
        //   break;
        case "3":
          // if(!this.site.length){

          this.GetDataSite({
            // id: this.select_id,
            search: this.page.search,
            agent_id: this.page.agent_id,
            p: 0,
            l: 10000,
          }).then((res) => {
            this.site_all = res.data;
          });

          this.GetDataSite({
            id: this.select_id,
            search: this.page.search,
            agent_id: this.page.agent_id,
            p: this.page.p,
            l: this.page.l,
          }).then((res) => {
            this.formatData(res.data);
            this.site = res.data;
            this.total = res.total;
          });
          // }
          break;

        default:
          break;
      }
    },
    formatData(data) {
      if (!data || data.length == 0) {
        this.loading = false;
        return;
      }
      let start = this.$moment(this.page.start, "YYYY-MM-DD"),
        end = this.$moment(this.page.end, "YYYY-MM-DD"),
        ids = [];
      data.map((item) => {
        ids.push(item.id);
        item.value = [
          {
            text: "打印",
            type: 1,
            num: 0,
            // result_pages: 0,
            total_pages: 0,
            A30: 0,
            A40: 0,
            A50: 0,
            A50: 0,
            other0: 0,
            A3450: 0,
            A31: 0,
            A41: 0,
            A51: 0,
            other1: 0,
            A3451: 0,
            colorRatio: 0,
            duplex: 0,
            duplexRatio: 0,
            money: 0,

            //A3单双面/A3双面 出纸数*2
            A30Other: 0, //a3黑白
            A31Other: 0, //a3彩色
            A40Other: 0, //a4黑白
            A41Other: 0, //a3彩色
          },
          {
            text: "复印",
            type: 2,
            num: 0,
            // result_pages: 0,
            total_pages: 0,
            A30: 0,
            A40: 0,
            A50: 0,
            other0: 0,
            A3450: 0,
            A31: 0,
            A41: 0,
            A51: 0,
            other1: 0,
            A3451: 0,
            colorRatio: 0,
            duplex: 0,
            duplexRatio: 0,
            money: 0,

            //A3单双面/A3双面 出纸数*2
            A30Other: 0, //a3黑白
            A31Other: 0, //a3彩色
            A40Other: 0, //a4黑白
            A41Other: 0, //a3彩色
          },
          {
            text: "扫描",
            type: 3,
            num: 0,
            // result_pages: 0,
            total_pages: 0,
            A30: 0,
            A40: 0,
            A50: 0,
            other0: 0,
            A3450: 0,
            A31: 0,
            A41: 0,
            A51: 0,
            other1: 0,
            A3451: 0,
            colorRatio: 0,
            duplex: 0,
            duplexRatio: 0,
            money: 0,

            //A3单双面/A3双面 出纸数*2
            A30Other: 0, //a3黑白
            A31Other: 0, //a3彩色
            A40Other: 0, //a4黑白
            A41Other: 0, //a3彩色
          },
          {
            text: "合计",
            type: 4,
            num: 0,
            // result_pages: 0,
            total_pages: 0,
            A30: 0,
            A40: 0,
            A50: 0,
            other0: 0,
            A3450: 0,
            A31: 0,
            A41: 0,
            A51: 0,
            other1: 0,
            A3451: 0,
            colorRatio: 0,
            duplex: 0,
            duplexRatio: 0,
            money: 0,

            //A3单双面/A3双面 出纸数*2
            A30Other: 0, //a3黑白
            A31Other: 0, //a3彩色
            A40Other: 0, //a4黑白
            A41Other: 0, //a3彩色1
          },
        ];
      });

      let role_params = [];
      if (typeof this.page.role == "number") {
        role_params = [this.page.role];
      } else if (typeof this.page.role == "object") {
        role_params = this.page.role;
      } else {
        //所有角色
        role_params = [1, 2, 3];
      }
      if (ids.length == 0) {
        return;
      }
      console.log("测测测", typeof this.page.money_type, this.page.money_type);
      let money_type = "-1";
      if (
        this.page.money_type !== "-1" &&
        (typeof this.page.money_type === "array" ||
          typeof this.page.money_type === "object")
      ) {
        money_type = this.page.money_type.join(",");
      } else if (
        this.page.money_type !== "-1" &&
        typeof this.page.money_type === "string"
      ) {
        money_type = this.page.money_type;
      }
      this.GetDataStatistics({
        start,
        end,
        type: this.current_type,
        ids: ids.join(","),
        role: role_params.join(","),
        money_type,
        brand: this.selectBrand,
      }).then((res) => {
        this.summary = res.total;
        this.loading = false;
        data.map((d) => {
          res.data.map((item) => {
            if (item.job_type === 6) {
              item.job_type = 2;
            } else if (item.job_type === 5) {
              item.job_type = 1;
            } else if (item.job_type === 7) {
              item.job_type = 1;
            }
            if (d.id === item.id) {
              d.value.map((val, index) => {
                if (d.id === item.id && val.type === item.job_type) {
                  val.num += item.num;
                  val.money += item.money;
                  val.duplex += item.duplex ? item.total_pages : 0;
                  val.total_pages += item.total_pages;
                  val[`${item.sizes}${item.color}`] += item.total_pages;

                  //其它 之前有问题
                  // if (item.sizes === "OTHER") {
                  //   if (item.color) val.other1 += item.total_pages;
                  //   else val.other0 += item.total_pages;
                  // }

                  // //如果是A3或者双面 就计数
                  // if (item.sizes === "A3" && !item.color) {
                  //   val.A30Other += item.total_pages;
                  //   if (item.duplex) {
                  //     // val.A30Other += item.total_pages;
                  //   }
                  // } else if (item.sizes === "A3" && item.color) {
                  //   val.A31Other += item.total_pages;
                  //   if (item.duplex) {
                  //     // val.A31Other += item.total_pages;
                  //   }
                  // }

                  // if (item.sizes !== "A3" && !item.color && item.duplex) {
                  //   val.A40Other += item.total_pages;
                  // } else if (item.sizes !== "A3" && item.color && item.duplex) {
                  //   val.A41Other += item.total_pages;
                  // }
                }
              });
            }
          });
        });
        data.map((item) => {
          item.value.map((it) => {
            it.A3450 = it.A30 + it.A40 + it.A50 + it.other0;
            it.A3451 = it.A31 + it.A41 + it.A51 + it.other1;
          });
        });

        data.map((item) => {
          let num = 0,
            // result_pages = 0,
            total_pages = 0,
            A30 = 0,
            A40 = 0,
            A50 = 0,
            A3450 = 0,
            A31 = 0,
            A41 = 0,
            A51 = 0,
            A3451 = 0,
            colorRatio = 0,
            duplex = 0,
            duplexRatio = 0,
            money = 0,
            other0 = 0,
            other1 = 0,
            //A3单双面/A3双面 出纸数*2
            A30Other = 0,
            A31Other = 0,
            A40Other = 0,
            A41Other = 0;
          item.value.map((it) => {
            // 不为合计情况下
            if (it.type !== 4) {
              (num += it.num),
                // (result_pages += it.result_pages),
                (total_pages += it.total_pages),
                (A30 += it.A30),
                (A40 += it.A40),
                (A50 += it.A50),
                (A3450 += it.A3450),
                (A31 += it.A31),
                (A41 += it.A41),
                (A51 += it.A51),
                (A3451 += it.A3451),
                (duplex += it.duplex),
                (money += it.money),
                (other0 += it.other0),
                (other1 += it.other1),
                //A3单双面/A3双面 出纸数*2
                (A30Other += it.A30Other),
                (A31Other += it.A31Other),
                (A40Other += it.A40Other),
                (A41Other += it.A41Other);
            }
          });
          item.value.map((to) => {
            if (to.type === 4) {
              (to.num = num),
                // (to.result_pages = result_pages),
                (to.total_pages = total_pages),
                (to.A30 = A30),
                (to.A40 = A40),
                (to.A50 = A50),
                (to.A3450 = A3450),
                (to.A31 = A31),
                (to.A41 = A41),
                (to.A51 = A51),
                (to.A3451 = A3451),
                (to.duplex = duplex),
                (to.money = money),
                (to.other0 = other0),
                (to.other1 = other1),
                //A3单双面/A3双面 出纸数*2
                (to.A30Other = A30Other),
                (to.A31Other = A31Other),
                (to.A40Other = A40Other),
                (to.A41Other = A41Other);
            }
          });
        });
        // 计算比例
        data.map((item) => {
          item.value.map((it) => {
            console.log("it.duplex", it.duplex);
            console.log("it.total_pages", it.total_pages);
            it.colorRatio =
              it.A3450 + it.A3451 === 0
                ? "0%"
                : parseInt((it.A3451 / (it.A3450 + it.A3451)) * 100) + "%";
            it.duplexRatio =
              it.duplex === 0
                ? "0%"
                : // : parseInt((it.duplex / it.result_pages) * 100) + "%";
                  parseInt((it.duplex / it.total_pages) * 100) + "%";
          });
        });
        this.loading = false;
        console.log(JSON.stringify(data));
        return data;
      });
    },
    onChangeSelectData(e) {
      switch (e) {
        case "0": //今日
          let now = new Date();
          this.page.start = this.$moment(now, "YYYY-MM-DD");
          this.page.end = this.$moment(now, "YYYY-MM-DD");
          break;
        case "1": //本月
          this.curMonth(true);
          break;
        case "2": //上月
          this.curMonth();
          break;
      }
    },
    // 重置获取数据
    reset() {
      this.page = {
        p: 0,
        l: 10,
        start: new Date(),
        end: new Date(),
        role: [],
        current_type: "0", //统计角度
        money_type: "-1", //统计角度
        machine_id: 0, //选择的设备ID
        agent_id: 0, //选择的合作伙伴ID
        search: "", //关键字
      };
      console.log('this.page', this.page)
      this.selectBrand = []
      this.select_id = "-1";
      this.radio = "0";
      this.current_type = "0";
      this.condChange(true);
    },
    getDataAgent() {
      this.GetDataAgent({
        p: this.page.p,
        l: this.page.l,
      }).then((res) => {
        this.agent = res.data;
      });
    },
    getData() {
      this.condChange(true);
    },
    roleChange(type) {
      if (typeof type == "number" || typeof type == "object") {
        this.role_multiple = true;
        if (typeof type == "object") {
          if (type.indexOf("-1") >= 0 || type.length == 0) {
            this.role_multiple = false;
            this.page.role = "-1";
          }
        }
      } else {
        this.role_multiple = false;
      }
    },
    changeDate() {
      this.radio = "";
    },
    showAllData() {
      // this.page.l = this.total;
      this.page.l = 1000;
      this.condChange();
    },
    //支付方式选择框监听
    money_type_change(money_type) {
      console.log("money_type", money_type);
      if (money_type.indexOf("-1") >= 0 || money_type.length === 0) {
        this.money_type_multiple = false;
        this.page.money_type = "-1";
      } else {
        this.page.money_type = JSON.parse(JSON.stringify(money_type));
        this.money_type_multiple = true;
      }
    },
    brandChange() {
      console.log("brandChange", this.current_type);
      if (this.current_type === "0") {
        //设备角度，重新获取设备列表

      }
      this.condChange();
    },
    ...mapActions([
      "GetDataMachine",
      "GetDataCompany",
      "GetDataAgent",
      "GetDataSite",
      "GetDataStatistics",
      "GetMachineTypeGroup",
    ]),
  },
  computed: mapGetters({
    user: "agent",
  }),
};
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
